import { useEffect, useState } from 'react'

/**
 * Hydration-safe device-pixel-ratio scale (capped at 2×) for image URLs.
 *
 * Reading `window.devicePixelRatio` during render is a server/client branch:
 * SSR assumes 2× while a 1×-display client computes 1× on the hydration pass —
 * an img-src mismatch that makes React discard the whole SSR tree. Initialise
 * to the SSR value (2×) so hydration matches byte-for-byte, then refine to the
 * real DPR after mount (re-render only when it differs, i.e. on 1× displays).
 */
export function useDevicePixelScale(): number {
  const [scale, setScale] = useState(2)
  useEffect(() => {
    const actual = Math.min(Math.ceil(window.devicePixelRatio || 1), 2)
    if (actual !== 2) setScale(actual)
  }, [])
  return scale
}
